import { useQueryClient } from '@tanstack/react-query';
import { customerServices } from '../services/customer.service';

export const usePrefetchCustomers = () => {
  const queryClient = useQueryClient();

  const prefetchNextPage = (filters, totalPages) => {
    const nextPage = parseInt(filters.page) + 1;
    if (nextPage <= totalPages) {
      queryClient.prefetchQuery({
        queryKey: ['customers', { ...filters, page: String(nextPage) }],
        queryFn: () => customerServices.getCustomers({ ...filters, page: String(nextPage) }),
      });
    }
  };

  const prefetchPrevPage = (filters) => {
    const prevPage = parseInt(filters.page) - 1;
    if (prevPage >= 1) {
      queryClient.prefetchQuery({
        queryKey: ['customers', { ...filters, page: String(prevPage) }],
        queryFn: () => customerServices.getCustomers({ ...filters, page: String(prevPage) }),
      });
    }
  };

  return { prefetchNextPage, prefetchPrevPage };
};
